module.exports = __webpack_public_path__ + "img/no-activated-sub-repositories-state.c6577fa.webp";